// extracted by mini-css-extract-plugin
export default {"emailList":"AuthorsList_emailList__G2EH1"};